const Wrapper: React.FC<{ children: JSX.Element }> = ({ children }) => {
  return (
    <div className="sc:w-[1349.4px] bg-ph-input w-full mx-auto">{children}</div>
  );
};

export default Wrapper;
